var exports = {
  "n": "x2b2fbebb--1dd781--row",
  "D": "x2b2fbebb--1dd781--title",
};

module.exports = exports;
